import {gsap} from "gsap";
import {DumpsterFire} from "../../DumpsterFire";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/reel/winpresentation/SimplePresentationRunner";
import {DumpsterFireGameMode} from "../../server/DumpsterFireGameMode";
import {DumpsterFireSound} from "../../sound/DumpsterFireSound";
import {DumpsterFireSymbol} from "../../reels/DumpsterFireSymbol";
import {ISymbol} from "../../../core/reel/simplereel/IReelData";


export class DFRoundEndPresentation implements SimplePresentation {
    constructor() {
    }

    shouldRun(): boolean {
        return DumpsterFire.model.data.nextMode != DumpsterFireGameMode.NORMAL_AVALANCHE && !(DumpsterFire.model.data.mode.indexOf("FREESPIN") > -1);
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                DumpsterFire.model.scatterCount = 0;
                DumpsterFire.model.scatterSymArray = [];
                controller.finish();
            }
        });
        tl.add([() => {
            DumpsterFire.model.upgradeStop = false;
            DumpsterFire.model.upgradeAvalancheStop = false;
            if (DumpsterFire.model.scatterCount < 5 && DumpsterFire.model.scatterCount > 1) {
                DumpsterFire.soundPlayer.stopAnticipationSound();
            }
            if (DumpsterFire.model.data.mode.indexOf("NORMAL") > -1 && DumpsterFire.model.data.nextMode === DumpsterFireGameMode.FREESPIN && DumpsterFire.model.data.upgradedSymbols.length > 0) {
                DumpsterFire.model.scatterSymArray.forEach((scatter: ISymbol) => {
                    DumpsterFire.winView.playGlow_2_Animation(<DumpsterFireSymbol>scatter)
                });
            } else {
                if (DumpsterFire.model.scatterCount > 1) {
                    DumpsterFire.model.scatterSymArray.forEach((scatter: ISymbol) => {
                        DumpsterFire.winView.playGlow_2_Animation(<DumpsterFireSymbol>scatter)
                    });
                }
            }
        },
            DumpsterFire.reelAnticipation.reset(false)
        ]);
        tl.add(() => controller.setSkipCallback());
        tl.add(gsap.to(this, {duration: 0.02}));
    }
}